export const SwitchText = {
  methods: {
    statusSwitch(value) {
      return value ? "Status Ativo" : "Status Inativo";
    }
  }
};
